import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col lg:flex-row justify-between items-start gap-4 mb-4 mt-4" }
const _hoisted_2 = {
  key: 1,
  class: "w-full flex flex-col lg:flex-row justify-between items-start gap-4 mb-8"
}
const _hoisted_3 = { class: "w-full lg:w-4/5" }
const _hoisted_4 = { class: "w-full lg:w-1/5" }
const _hoisted_5 = {
  class: "w-full mt-4 overflow-y-auto overflow-x-hidden",
  style: {"grid-area":"table"}
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"hidden md:grid lg:grid-cols-12 md:grid-cols-8 gap-2 w-full items-center text-left py-2 border-b font-semibold text-gray-700 text-xs md:text-sm\"><div class=\"md:col-span-3\">Nome</div><div class=\"md:col-span-1\">CRM</div><div class=\"md:col-span-1\">CRM-UF</div><div class=\"md:col-span-2\">Data de Inserção</div><div class=\"md:col-span-3\">Inserido Por</div><div class=\"md:col-span-2 flex\">Ações</div></div>", 1)

import { computed, ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'

import { mdiPlusCircle } from '@mdi/js'
import { formatDateTimeAtBR } from '@/utils/date'
import { useDsPolicyStore } from '@/pinia-store/useDsPolicyStore'
import {
  useDoctorStore,
  DOCTOR_FETCH_ALL_LIMIT,
  DOCTORS_LOAD_ERROR
} from '@/pinia-store/useDoctorStore'
import { useErrorToast } from '@/composables/useErrorToast'
import { useDoctorsLoadError } from '../useDoctorsLoadError'

import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import TableBlockedPolicies from '@/components/designSystem/Table/TableBlockedDsPolicies.vue'
import EmptyList from '@/components/EmptyList.vue'
import DsPolicyBlockedSkeleton from '@/components/designSystem/Skeleton/DsPolicyBlockedSkeleton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'blocked.tab',
  emits: ['update:users'],
  setup(__props, { emit }) {

const { notifyError } = useErrorToast()
const loading = ref(false)

const currentPage = ref(1)
const itemsPerPage = ref(5)

const dsPolicyStore = useDsPolicyStore()
const doctorStore = useDoctorStore()

const { blockedDoctors } = storeToRefs(dsPolicyStore)
const { doctorsCompany } = storeToRefs(doctorStore)

const showInsert = ref(false)
const loadingBloqued = ref(false)
const selectedUsers = ref<string[]>([])

const { notifyDoctorsLoadError } = useDoctorsLoadError()

onMounted(async () => {
  loading.value = true
  try {
    doctorStore.doctorQuery.limit = DOCTOR_FETCH_ALL_LIMIT
    await doctorStore.fetchDoctors()
    notifyDoctorsLoadError()
  } catch (err) {
    notifyError(err, DOCTORS_LOAD_ERROR)
  }

  try {
    const policyId = dsPolicyStore.currentPolicy?.id
    if (policyId) await dsPolicyStore.fetchBlockedDoctorsByDsPolicy(policyId)
  } catch (err) {
    notifyError(err, 'Não foi possível carregar os médicos bloqueados da política.')
  } finally {
    loading.value = false
  }
})

const toggleInsert = () => {
  showInsert.value = !showInsert.value
}



const setUsers = (v: string[]) => {
  selectedUsers.value = v
  emit('update:users', v)
}

const searchUsers = async (search: string) => {
  try {
    loadingBloqued.value = true
    await doctorStore.applyFilters({ search }, false)
    doctorsCompany.value = doctorStore.doctorsCompany
    notifyDoctorsLoadError()
  } catch (error) {
    notifyError(error, DOCTORS_LOAD_ERROR)
  } finally {
    loadingBloqued.value = false
  }
}

const submitUsers = async () => {
  const policyId = Number(dsPolicyStore.currentPolicy?.id)

  // Guard local (estado da tela, não erro de API) — fica fora do notifyError.
  if (!policyId || isNaN(policyId)) {
    console.error('Policy ID inválido:', policyId)
    return
  }

  const doctorIds = selectedUsers.value.map(Number)

  const payload = {
    dsPolicyId: policyId,
    doctorIds
  }

  loading.value = true
  try {
    await dsPolicyStore.addBlockedDoctors(policyId, payload)
  } catch (err) {
    // Mantém a seleção e o formulário aberto para o usuário tentar de novo.
    notifyError(err, 'Não foi possível bloquear os médicos na política de restrição.')
    loading.value = false
    return
  }

  selectedUsers.value = []
  showInsert.value = false

  try {
    await dsPolicyStore.fetchBlockedDoctorsByDsPolicy(policyId)
  } catch (err) {
    notifyError(err, 'Não foi possível atualizar a lista de médicos bloqueados.')
  } finally {
    loading.value = false
  }
}

const paginatedDoctors = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value
  const end = start + itemsPerPage.value
  return blockedDoctors.value.slice(start, end)
})

const pageCount = computed(() => Math.ceil(blockedDoctors.value.length / itemsPerPage.value))

const changePage = (page: number) => {
  currentPage.value = page
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createBlock(DsPolicyBlockedSkeleton, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        onClick: toggleInsert,
        class: "flex items-center gap-2 cursor-pointer font-bold text-primary"
      }, [
        _createVNode(_component_v_icon, {
          class: "share-icon",
          color: "primary",
          icon: _unref(mdiPlusCircle),
          size: "32"
        }, null, 8, ["icon"]),
        _createTextVNode(" Inserir Médicos ")
      ])
    ]),
    (showInsert.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_autocomplete, {
              "onUpdate:modelValue": setUsers,
              "onUpdate:search": searchUsers,
              items: _unref(doctorStore).listDoctorsCompany,
              loading: loadingBloqued.value,
              clearable: "",
              chips: "",
              multiple: "",
              class: "w-full",
              color: "primary20",
              label: "Médicos",
              variant: "outlined",
              density: "comfortable"
            }, null, 8, ["items", "loading"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(FilledButton, {
              onClick: submitUsers,
              loading: loadingBloqued.value,
              text: `Inserir Médicos`,
              width: "100%",
              height: "56px",
              disabled: loading.value
            }, null, 8, ["loading", "disabled"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (!loading.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (paginatedDoctors.value.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_6,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedDoctors.value, (doc) => {
                    return (_openBlock(), _createBlock(TableBlockedPolicies, {
                      key: doc.id,
                      data: {
            id: doc.id,
            name: doc.doctor.user.name,
            crm: doc.doctor.mainCrm.number,
            crmUf: doc.doctor.mainCrm.uf,
            insertedAt: _unref(formatDateTimeAtBR)(doc.createdAt),
            insertedBy: doc.createdBy.name
          }
                    }, null, 8, ["data"]))
                  }), 128))
                ], 64))
              : (_openBlock(), _createBlock(EmptyList, {
                  key: 1,
                  title: "Nenhum médico bloqueado encontrado"
                }))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_unref(blockedDoctors).length > 0)
      ? (_openBlock(), _createBlock(_component_v_pagination, {
          key: 2,
          modelValue: currentPage.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
            changePage
          ],
          "total-visible": 5,
          length: pageCount.value,
          density: "comfortable",
          color: "primary"
        }, null, 8, ["modelValue", "length"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})